import { useCallback, useEffect, useState } from "react";
import { User } from "../../../network/mainClient/types";
import { updateCurrentUser } from "../../../network/mainClient/user";
import { ApiError, toApiError } from "../../../network/mainClient/apiError";

export const useUpdateCurrentUser = (): [
  User | null,
  boolean,
  ApiError | null,
  (name: string) => Promise<void>
] => {
  const [result, setResult] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<ApiError | null>(null);

  const request = useCallback(async (name: string) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await updateCurrentUser(name);
      setResult(response);
    } catch (e) {
      setError(toApiError(e));
      throw e;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return [result, isLoading, error, request];
};
